<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <!-- SINGLE LOGOS -->

    <!--    <div class="surface-overlay py-3 px-6 shadow-2 flex align-items-center justify-content-between relative lg:static"-->
    <!--         style="min-height: 80px">-->
    <!--        <img src="images/blocks/logos/kitrin-logo-black-revised-software-rev2.png" alt="Kitrin IsoEvolve" height="45" class="mr-0 lg:mr-6"/>-->
    <!--        <a v-ripple class="cursor-pointer block lg:hidden text-700 mt-1 p-ripple"-->
    <!--           v-styleclass="{ selector: '@next', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">-->
    <!--            <i class="pi pi-bars text-4xl"></i>-->
    <!--        </a>-->
    <!--        <div-->
    <!--            class="align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none">-->
    <!--            <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row">-->
    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Overview</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->
    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->

    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Clients</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->
    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->


    <!--                <li>-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
    <!--                        <i class="pi pi-calendar mr-2"></i>-->
    <!--                        <span>Calendar</span>-->
    <!--                    </a>-->
    <!--                </li>-->

    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Financials</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->
    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->


    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Account</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->
    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->

    <!--                <li class="lg:relative">-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple"-->
    <!--                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                        <i class="pi pi-users mr-2"></i>-->
    <!--                        <span>Configuration</span>-->
    <!--                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>-->
    <!--                    </a>-->
    <!--                    <ul class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer">-->
    <!--                        <li>-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                <i class="pi pi-user-plus mr-2"></i>-->
    <!--                                <span class="font-medium">Dashboard</span>-->
    <!--                            </a>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Audit Trail</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailOverview" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Overview</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li>-->
    <!--                                    <a @click="processAuditTrailNew" v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">New Audit Trail</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                        <li class="relative">-->
    <!--                            <a v-ripple-->
    <!--                               class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple"-->
    <!--                               v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">-->
    <!--                                <i class="pi pi-search mr-2"></i>-->
    <!--                                <span class="font-medium">Search</span>-->
    <!--                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>-->
    <!--                            </a>-->
    <!--                            <ul class="list-none py-3 pl-3 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">-->
    <!--                                <li>-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-shopping-cart mr-2"></i>-->
    <!--                                        <span class="font-medium">Purchases</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                                <li class="relative">-->
    <!--                                    <a v-ripple-->
    <!--                                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150 p-ripple">-->
    <!--                                        <i class="pi pi-comments mr-2"></i>-->
    <!--                                        <span class="font-medium">Messages</span>-->
    <!--                                    </a>-->
    <!--                                </li>-->
    <!--                            </ul>-->
    <!--                        </li>-->
    <!--                    </ul>-->
    <!--                </li>-->

    <!--                <li>-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
    <!--                        <i class="pi pi-chart-line mr-2"></i>-->
    <!--                        <span>Applications</span>-->
    <!--                    </a>-->
    <!--                </li>-->
    <!--            </ul>-->
    <!--            <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">-->
    <!--                <li>-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
    <!--                        <i class="pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0" v-badge.danger></i>-->
    <!--                        <span class="block lg:hidden font-medium">Notifications</span>-->
    <!--                    </a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                    <a v-ripple-->
    <!--                       class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
    <!--                        <i class="pi pi-power-off text-base lg:text-2xl mr-2 lg:mr-0"></i>-->
    <!--                        <span class="block lg:hidden font-medium">Logout</span>-->
    <!--                    </a>-->
    <!--                </li>-->
    <!--            </ul>-->
    <!--        </div>-->
    <!--    </div>-->

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a class="cursor-pointer">Operational Clarity</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Suppliers</a></li>
        </ul>

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Suppliers</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewSupplier" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Supplier</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callHelp" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Help</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable
                        :value="suppliers"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        v-model:filters="filters"
                        filterDisplay="menu"
                        :loading="loading"
                        responsiveLayout="scroll"
                        :globalFilterFields="['name', 'uniqueId', 'tradingName', 'email', 'phone']">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedColumns" :options="columnsFullList"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleColumns"
                                                     display="chip" placeholder="Select Columns"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedStandardFilter" :options="standardFilters"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleStandardFilters"
                                                     display="chip" placeholder="Select Standard Filter"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-replay" label="Restore to Original View"
                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                    </div>
                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filters['global'].value"
                                                   placeholder="Keyword Search on Name, Unique ID, Trading Name, Email or Phone"
                                                   style="width: 100%"/>
                                    </span>
                                </div>
                            </div>

                        </template>

                        <template #empty>
                            No suppliers found.
                        </template>

                        <template #loading>
                            Loading suppliers. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <SplitButton icon="pi pi-pencil" label="Select" :model="getFilteredItems(data)"
                                             severity="success"
                                             @click="chooseBlankSelection(data)" class="mb-2 mr-2 ml-2 mt-2"/>
                            </template>
                        </Column>

                        <Column field="uniqueId" header="Unique ID" :sortable="true"/>
                        <Column field="name" header="Name" :sortable="true"/>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                                <span v-if="data.status === 'A'"
                                      :class="'status-badge status-' + data.status">Active</span>
                            </template>
                        </Column>

                        <Column field="type" header="Type" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Type</span>
                                <span v-if="data.type === 'S'"
                                      :class="'type-badge status-' + data.type">Sole Proprietor</span>
                                <span v-if="data.type === 'P'"
                                      :class="'type-badge status-' + data.type">Private Company</span>
                                <span v-if="data.type === 'N'"
                                      :class="'type-badge status-' + data.type">Non-Profit Company</span>
                                <span v-if="data.type === 'L'"
                                      :class="'type-badge status-' + data.type">Limited Company</span>
                                <span v-if="data.type === 'I'"
                                      :class="'type-badge status-' + data.type">Incorporation</span>
                                <span v-if="data.type === 'C'"
                                      :class="'type-badge status-' + data.type">Co-operative</span>
                            </template>
                        </Column>

                        <template v-for="col in selectedColumns" :key="col.field">
                            <Column v-if="col.field !== 'taxRegistered'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable"/>
                            <Column v-else :field="col.field" :header="col.header" :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Tax Registered?</span>
                                    <span v-if="data.taxRegistered === 'Y'"
                                          :class="'status-badge status-' + data.taxRegistered">Yes</span>
                                    <span v-else
                                          :class="'status-badge status-' + data.taxRegistered">No</span>
                                </template>
                            </Column>
                        </template>


                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Supplier {{ this.supplier.name }}</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="supplier.type" :options="companyTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="Name">Supplier Name</label>
                        <InputText id="name" v-model.trim="supplier.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="tradingName">Trading Name</label>
                        <InputText id="tradingName" v-model.trim="supplier.tradingName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="registrationNumber">Registration Number</label>
                        <InputText id="registrationNumber" v-model.trim="supplier.registrationNumber" required="true"/>
                    </div>

                    <div class="field">
                        <label for="uniqueId">Unique #</label>
                        <InputText id="uniqueId" v-model.trim="supplier.uniqueId" required="true"/>
                    </div>

                    <div class="field">
                        <label for="address1">Address 1</label>
                        <InputText id="address1" v-model.trim="supplier.address1" required="true"/>
                    </div>

                    <div class="field">
                        <label for="address2">Address 2</label>
                        <InputText id="address2" v-model.trim="supplier.address2" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressRegion">Address Region</label>
                        <InputText id="addressRegion" v-model.trim="supplier.addressRegion" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressState">Address State</label>
                        <InputText id="addressState" v-model.trim="supplier.addressState" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Address Postal Code</label>
                        <InputText id="addressPostalCode" v-model.trim="supplier.addressPostalCode" required="true"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" v-model.trim="supplier.email" required="true"/>
                    </div>

                    <div class="field">
                        <label for="phone">Phone</label>
                        <InputText id="phone" v-model.trim="supplier.phone" required="true"/>
                    </div>

                    <div class="field">
                        <label for="taxRegistered">Tax Registered?</label>
                        <Dropdown v-model="supplier.taxRegistered" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select Option"/>
                    </div>

                    <div v-if="this.supplier.taxRegistered === 'Y'" class="field">
                        <label for="taxNumber">Tax Number</label>
                        <InputText id="taxNumber" v-model.trim="supplier.taxNumber" required="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <br>
                        <Dropdown v-model="supplier.status" :options="statusTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" @click="updateSupplier"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Supplier {{ this.supplier.name }}</h3>

                    <div class="field">
                        <label for="deleteConfirmationResponse">Do You Wish to Delete this Supplier?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deleteSupplier"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>New Supplier</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="newSupplier.type" :options="companyTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="Name">Company Name</label>
                        <InputText id="name" v-model.trim="newSupplier.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="tradingName">Trading Name</label>
                        <InputText id="tradingName" v-model.trim="newSupplier.tradingName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="registrationNumber">Registration Number</label>
                        <InputText id="registrationNumber" v-model.trim="newSupplier.registrationNumber"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="uniqueId">Unique #</label>
                        <InputText id="uniqueId" v-model.trim="newSupplier.uniqueId" required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressCountry">Country</label>
                        <Dropdown v-model="newSupplier.addressCountry" :options="countries"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="address1">Address Line 1</label>
                        <InputText id="address1" v-model.trim="newSupplier.address1"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="address2">Address Line 2</label>
                        <InputText id="address2" v-model.trim="newSupplier.address2"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressRegion">Region</label>
                        <InputText id="addressRegion"
                                   v-model.trim="newSupplier.addressRegion"
                                   required="true"/>
                    </div>

                    <div v-show="newSupplier.addressCountry==='ZA'" class="field">
                        <label for="addressState">Province</label>
                        <Dropdown v-model="newSupplier.addressState" :options="regionsSouthAfrica"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div v-show="newSupplier.addressCountry==='UK'" class="field">
                        <label for="addressState">County</label>
                        <InputText id="addressState" v-model.trim="newSupplier.addressState"
                                   required="true"/>
                    </div>

                    <div v-show="newSupplier.addressCountry!='ZA' && newSupplier.addressCountry!='UK'"
                         class="field">
                        <label for="addressState">State</label>
                        <InputText id="addressState" v-model.trim="newSupplier.addressState"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Postal Code</label>
                        <InputText id="addressPostalCode"
                                   v-model.trim="newSupplier.addressPostalCode"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" v-model.trim="newSupplier.email" required="true"/>
                    </div>

                    <div class="field">
                        <label for="phone">Phone</label>
                        <InputText id="phone" v-model.trim="newSupplier.phone" required="true"/>
                    </div>

                    <div class="field">
                        <label for="taxRegistered">Tax Registered?</label>
                        <Dropdown v-model="newSupplier.taxRegistered" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select Option"/>
                    </div>

                    <div class="field">
                        <label for="taxNumber">Tax Number</label>
                        <InputText id="taxNumber" v-model.trim="newSupplier.taxNumber" required="true"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" @click="createSupplier"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import CompanyService from "@/service/CompanyService";
import SupplierService from "@/service/SupplierService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();

        this.columnsDefault = [
            {field: 'tradingName', header: 'Trading Name', sortable: true},
            {field: 'email', header: 'Email', sortable: true},
            {field: 'phone', header: 'Phone', sortable: true}
        ];

        this.columnsFullList = [
            {field: 'tradingName', header: 'Trading Name', sortable: true},
            {field: 'email', header: 'Email', sortable: true},
            {field: 'phone', header: 'Phone', sortable: true},
            {field: 'registrationNumber', header: 'Registration #', sortable: true},
            {field: 'taxRegistered', header: 'Tax Registered?', sortable: true},
            {field: 'taxNumber', header: 'Tax #', sortable: true},
            {field: 'address1', header: 'Address Line 1', sortable: true},
            {field: 'address2', header: 'Address Line 2', sortable: true},
            {field: 'addressRegion', header: 'Region', sortable: true},
            {field: 'addressState', header: 'State', sortable: true},
            {field: 'addressCountry', header: 'Country', sortable: true},
            {field: 'addressPostalCode', header: 'Postal Code', sortable: true}
        ];

        this.selectedColumns = this.columnsDefault;

        this.standardFilters = [
            {field: 'today', header: 'Today'},
            {field: 'thisMonth', header: 'This Month'}
        ];

    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            companyConfiguration: {},
            userConfiguration: {},
            filters: null,
            loading: true,
            submitted: false,
            filteredItemsCache: new Map(),
            supplier: {},
            newSupplier: {},
            suppliers: null,
            originalSuppliers: null,
            clientSuppliers: null,
            confirmationResponse: 'N',
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            selectedStandardFilter: null,
            standardFilters: null,
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            statusTypes: [
                {name: 'Active', code: 'A'},
                {name: 'Inactive', code: 'I'}
            ],
            companyTypes: [
                {name: 'Sole Proprietor', code: 'S'},
                {name: 'Private Company', code: 'P'},
                {name: 'Non-Profit Company', code: 'N'},
                {name: 'Limited Company', code: 'L'},
                {name: 'Incorporation', code: 'I'},
                {name: 'Co-operative', code: 'C'}
            ],
            countries: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'India', code: 'IN'},
                {name: 'United States', code: 'US'},
                {name: 'Namibia', code: 'NA'},
                {name: 'Australia', code: 'AU'},
                {name: 'New Zealand', code: 'NZ'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'Slovenia', code: 'SV'},
                {name: 'Taiwan', code: 'TW'},
                {name: 'Other', code: 'OT'}
            ],
            regionsSouthAfrica: [
                {name: 'Gauteng', code: 'Gauteng'},
                {name: 'Western Cape', code: 'Western Cape'},
                {name: 'Kwa-Zulu Natal', code: 'Kwa-Zulu Natal'},
                {name: 'North-West', code: 'North-West'},
                {name: 'Free State', code: 'Free State'},
                {name: 'Eastern Cape', code: 'Eastern Cape'},
                {name: 'Mpumalanga', code: 'Mpumalanga'},
                {name: 'Northern Cape', code: 'Northern Cape'},
                {name: 'Limpopo', code: 'Limpopo'}
            ]
        }
    },
    watch: {
        suppliers() {
            this.filteredItemsCache.clear();
        },
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                try {
                    // Attempt to get user data
                    const userData = await UserService.getUser(this.userStore.user.id);
                    this.profile = userData.data;
                } catch (e) {
                    console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                    this.userStore.clearUser();
                    this.$router.push('login');
                    return;
                }

                this.profile.companyId = this.userStore.activeCompanyId;

                const [userConfigurationData, companyConfigurationData, suppliersData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id),
                    CompanyService.getCompanyConfiguration(this.profile.companyId),
                    SupplierService.getCompanySuppliers(this.profile.companyId)
                ]);

                this.userConfiguration = userConfigurationData.data;
                this.companyConfiguration = companyConfigurationData.data;

                this.suppliers = suppliersData.data;
                this.originalSuppliers = [...this.suppliers];

                this.loading = false;

            } catch (e) {
                console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
            }

            console.log("[PhoneCalls][mounted] this.suppliers = ", this.suppliers);
            console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
            console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'name': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'uniqueId': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'tradingName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }, 'email': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'phone': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            window.location.reload();
        },
        callReset() {
            this.activeTab = 1;
        },
        callNewSupplier() {
            this.newSupplier = {
                status: 'A',
                taxRegistered: 'N',
                type: 'P',
                addressCountry: 'ZA'
            };

            this.activeTab = 4;
        },
        callHelp() {
            console.log('[ConfigurationBilling][callHelp] Start.');
        },
        callSupport() {
            console.log('[ConfigurationBilling][callSupport] Start.');
        },
        callUpdateSupplier(data) {
            this.activeTab = 2;
            this.supplier = data;
        },
        callDeleteSupplier(data) {
            this.activeTab = 3;
            this.confirmationResponse = 'N';
            this.supplier = data;
        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        },
        onToggleStandardFilters(value) {

            if (value.length > 1) {
                // Keep the last selected option
                this.selectedStandardFilter = [value[value.length - 1]];
            } else {
                this.selectedStandardFilter = value;
            }

            const isTodaySelected = value.some(item => item.field === "today");
            const isThisMonthSelected = value.some(item => item.field === "thisMonth");

            if (this.suppliers !== null) {

                if (isTodaySelected) {
                    // The filter "today" is present in selectedStandardFilters
                    console.log("[PhoneCalls] The filter 'today' is selected.");

                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JS
                    const day = String(today.getDate()).padStart(2, '0');
                    const todayStr = `${year}-${month}-${day}`;

                    this.suppliers = this.originalSuppliers.filter(supplier => {
                        // Assuming 'created' is in 'YYYY-MM-DD' format
                        return supplier.created.startsWith(todayStr);
                    });

                } else if (isThisMonthSelected) {
                    console.log("[PhoneCalls] The filter 'thisMonth' is selected.");

                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JS
                    const monthStr = `${year}-${month}`;

                    this.suppliers = this.originalSuppliers.filter(supplier => {
                        // Assuming 'created' is in 'YYYY-MM-DD' format
                        return supplier.created.startsWith(monthStr);
                    });

                } else {
                    // The filter "today" is not present in selectedStandardFilters
                    console.log("[PhoneCalls] No filters were selected.");
                    this.suppliers = this.originalSuppliers;
                }

            } else {
                // Handle the case when auditTrails is null
                this.suppliers = null;
            }
        },
        getFilteredItems(data) {
            if (this.filteredItemsCache.has(data.id)) {
                return this.filteredItemsCache.get(data.id);
            }

            const items = [];

            items.push({
                label: 'Update',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    console.log('Update action');
                    this.callUpdateSupplier(data);
                }
            });

            items.push({
                label: 'Delete',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    console.log('Delete action');
                    this.callDeleteSupplier(data);
                }
            });

            console.log('[PhoneCalls][getFilteredItems] items = ', items);

            this.filteredItemsCache.set(data.id, items);

            return items;
        },
        chooseBlankSelection(data) {
            console.log('[PhoneCalls][chooseBlankSelection] data = ', data);
            this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select a valid option.',
                life: 3000
            });
        },
        async updateSupplier() {
            console.log("[PhoneCalls][updatePhoneCall] Start.");

            this.submitted = true;

            if (this.supplier.name.trim()) {

                try {

                    console.log('[PhoneCalls][updatePhoneCall] this.supplier = ', this.supplier);

                    if (this.supplier.taxRegistered.trim() === "N") {
                        this.supplier.taxNumber = "";
                    }

                    console.log('[PhoneCalls][updatePhoneCall] this.supplier = ', this.supplier);

                    var supplierDto = {
                        name: this.supplier.name,
                        tradingName: this.supplier.tradingName,
                        registrationNumber: this.supplier.registrationNumber,
                        uniqueId: this.supplier.uniqueId,
                        type: this.supplier.type,
                        address1: this.supplier.address1,
                        address2: this.supplier.address2,
                        addressRegion: this.supplier.addressRegion,
                        addressState: this.supplier.addressState,
                        addressCountry: this.supplier.addressCountry,
                        addressPostalCode: this.supplier.addressPostalCode,
                        email: this.supplier.email,
                        phone: this.supplier.phone,
                        taxRegistered: this.supplier.taxRegistered,
                        taxNumber: this.supplier.taxNumber,
                        status: this.supplier.status
                    };

                    const response = await SupplierService.updateSupplier(this.supplier.id, supplierDto);
                    console.log('[PhoneCalls][updatePhoneCall] Response = ', response);

                    const [supplierData] = await Promise.all([
                        SupplierService.getCompanySuppliers(this.profile.companyId)
                    ]);

                    this.suppliers = supplierData.data;
                    this.originalSuppliers = supplierData.data;
                    this.userStore.setSuppliers(supplierData.data);

                    console.log('[PhoneCalls][updatePhoneCall] this.suppliers = ', this.suppliers);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated supplier',
                        life: 3000
                    });
                } catch (error) {
                    console.error('[PhoneCalls][updatePhoneCall] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update supplier. Please try again.',
                        life: 3000
                    });
                }
            }

            this.supplier = {};
            this.activeTab = 1;
            this.submitted = false;

        },
        async deleteSupplier() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.supplier.id) {

                    try {
                        // Delete the appointment
                        const response = await SupplierService.deleteSupplier(this.supplier.id);
                        console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                        const [supplierData] = await Promise.all([
                            SupplierService.getCompanySuppliers(this.profile.companyId)
                        ]);

                        this.suppliers = supplierData.data;
                        this.originalSuppliers = supplierData.data;
                        this.userStore.setSuppliers(supplierData.data);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted supplier',
                            life: 3000
                        });

                    } catch (error) {
                        console.error('[PhoneCalls][deletePhoneCall] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete supplier. Please try again.',
                            life: 3000
                        });
                    }
                }

            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async createSupplier() {
            console.log("[PhoneCalls][createSupplier] Start.");

            this.submitted = true;

            if (this.newSupplier.name.trim()) {

                try {

                    if (this.newSupplier.taxRegistered.trim() === "N") {
                        this.newSupplier.taxNumber = "";
                    }

                    console.log('[PhoneCalls][updatePhoneCall] this.newSupplier = ', this.newSupplier);

                    var supplierDto = {
                        name: this.newSupplier.name,
                        tradingName: this.newSupplier.tradingName,
                        registrationNumber: this.newSupplier.registrationNumber,
                        uniqueId: this.newSupplier.uniqueId,
                        type: this.newSupplier.type,
                        address1: this.newSupplier.address1,
                        address2: this.newSupplier.address2,
                        addressRegion: this.newSupplier.addressRegion,
                        addressState: this.newSupplier.addressState,
                        addressCountry: this.newSupplier.addressCountry,
                        addressPostalCode: this.newSupplier.addressPostalCode,
                        email: this.newSupplier.email,
                        phone: this.newSupplier.phone,
                        taxRegistered: this.newSupplier.taxRegistered,
                        taxNumber: this.newSupplier.taxNumber,
                        status: this.newSupplier.status
                    };

                    const response = await SupplierService.createSupplier(this.profile.companyId, supplierDto);
                    console.log('[PhoneCalls][updatePhoneCall] Response = ', response);

                    const [supplierData] = await Promise.all([
                        SupplierService.getCompanySuppliers(this.profile.companyId)
                    ]);

                    this.suppliers = supplierData.data;
                    this.originalSuppliers = supplierData.data;
                    this.userStore.setSuppliers(supplierData.data);

                    console.log('[PhoneCalls][updatePhoneCall] this.suppliers = ', this.suppliers);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created supplier',
                        life: 3000
                    });
                } catch (error) {
                    console.error('[PhoneCalls][updatePhoneCall] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create supplier. Please try again.',
                        life: 3000
                    });
                }
            }

            this.newSupplier = {};
            this.activeTab = 1;
            this.submitted = false;

        },
    },
};
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

::v-deep(.p-datatable-frozen-tbody) {
    font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
    font-weight: bold;
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.status-badge, .type-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-I {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-A {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-Y {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-N {
        background: #B3E5FC;
        color: #23547B;
    }

}

.type-badge {
    &.status-S {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-P {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-N {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-L {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-I {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-C {
        background: #FFD8B2;
        color: #805B36;
    }
}

.tabview-custom {
    i, span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-tabview p {
    line-height: 1.5;
    margin: 0;
}

.accordion-custom {
    i, span {
        vertical-align: middle;
    }

    span {
        margin: 0 .5rem;
    }
}

.p-accordion p {
    line-height: 1.5;
    margin: 0;
}

.mb-2 {
    margin-bottom: 1rem;
}

.mr-2 {
    margin-right: 1rem;
}

</style>
